"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panel = void 0;
require("react-datepicker/dist/react-datepicker.css");
var React = require("react");
require("./Panel.scss");
var Panel = function (props) {
    return (React.createElement("div", { className: "panel-wrapper" },
        props.header && React.createElement("div", { className: "panel-header" }, props.header),
        React.createElement("div", { className: "panel-body" }, props.children)));
};
exports.Panel = Panel;
//# sourceMappingURL=Panel.js.map